import useVariantSearch from '../hooks/useVariantSearch/useVariantSearch'
import VariantSkuFilter from '../VariantSkuFilter/VariantSkuFilter'

const VariantSkuFilterField = ({ value, onChangeValue, isUnifiedDashboard }) => {
  const { variants, gettingVariants, handleSearchVariants, handleSelectVariant, handleDeleteVariant } =
    useVariantSearch({
      isUnifiedDashboard,
      variantsSkus: value.variantsSkus || [],
      onChangeSkus: skus => onChangeValue({ variantsSkus: skus }),
    })

  return (
    <VariantSkuFilter
      variants={variants}
      handleSearchVariants={handleSearchVariants}
      handleSelectVariant={handleSelectVariant}
      handleDeleteVariant={handleDeleteVariant}
      gettingVariants={gettingVariants}
      variantsSkusSelected={value.variantsSkus || []}
    />
  )
}

export default VariantSkuFilterField
